module.exports = __webpack_public_path__ + "static/media/55.936fff45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/55.jpg
// module id = 423
// module chunks = 0